import {Injectable} from '@angular/core'
import {BaseApiEndpointService} from '../BaseApiEndpoint.service'
import {Backend} from "@generated-backend-types";
import {ListItem} from "ng-multiselect-dropdown/multiselect.model";
import Email = Backend.App.Http.Resources.Dashboard.Administrations.Email;
import EmailData = Backend.App.Data.Administrations.EmailData;

@Injectable({
  providedIn: 'root'
})
export class EmailService extends BaseApiEndpointService<Email, EmailData> {
  protected override endpoint = '/administrations/emails'
  public override readonly multiSelectSortBy = 'title'

  modelToMultiSelectItem(m: Backend.App.Http.Resources.Dashboard.Administrations.Email): ListItem & {
    model: Backend.App.Http.Resources.Dashboard.Administrations.Email
  } {
    return {
      id: m.id,
      text: m.title,
      isDisabled: false,
      model: m,
    }
  }
}
